import React from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';
import { useContext } from './context';

export function YearSelector(props) {
  const { sx } = props;
  const { years, year, setYear } = useContext();

  function handleYearChange(event) {
    setYear(event.target.value);
  }

  return (
    <FormControl sx={{ ...sx }}>
      <Select
        sx={{ maxHeight: 36.5, boxShadow: 1 }}
        labelId="year-label"
        id="year"
        data-testid="year-selector"
        value={year}
        onChange={handleYearChange}
        variant="outlined"
      >
        {years.map((y) => (
          <MenuItem key={y} value={y}>
            {y}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
